import { Button, Icon } from "@chakra-ui/react";
import useIcons from "../../hooks/useIcons";

interface Props {
  handleLogout: () => void;
}

export default function MobileLogoutButton({ handleLogout }: Props) {
  const icons = useIcons();

  return (
    <Button
      variant="ghost"
      size="sm"
      aria-label="log out"
      onClick={handleLogout}
    >
      <Icon as={icons.utility.logout} mr={2} />
      Log out
    </Button>
  );
}
